module.exports = "/_next/static/images/OgResources-c0a58f05a8c20db7722fc7fb90d6f5b4.png";